import { createSelector } from 'reselect';
import type { RootState } from 'store';

const getDeviceDimensions = (state: RootState) => state.deviceDimensions;

export default createSelector([getDeviceDimensions], deviceDimensions => {
  return deviceDimensions && deviceDimensions.height < 500;
});
